import React from "react";

import SFTypography from "../typography";
import getStyled from "../../hooks/getStyled";
import InfoIcon from "@mui/icons-material/Info";

const { styled } = getStyled();

const StyledForm = styled("div", {
  shouldForwardProps: (prop) => prop !== "addBottomMargin",
})(({ theme, addBottomMargin }) => ({
  border: `1px ${theme.palette.grey200.main} solid`,
  background: theme.palette.white.main,
  borderRadius: 4,
  padding: 24,
  ...(addBottomMargin && { marginBottom: 24 }),
  "> .MuiTypography-body1": { paddingBottom: 24 },
  "> .MuiTypography-body1bold": {
    paddingBottom: 24,
    display: "flex",
    alignItems: "center",
    ".MuiSvgIcon-root": {
      marginRight: 4,
    },
  },
}));

const StyledHeading = styled(SFTypography)(({ theme }) => ({
  paddingBottom: 24,
  display: "flex",
  alignItems: "center",
  ".MuiSvgIcon-root": {
    marginRight: 8,
  },
}));

const StyledSubHeading = styled(SFTypography)(({ theme }) => ({
  borderBottom: `1px ${theme.palette.grey200.main} solid`,
  marginLeft: -24,
  marginRight: -24,
  paddingLeft: 24,
  paddingRight: 24,
  paddingBottom: 12,
  marginBottom: 24,
}));

//import { useTranslation } from "react-i18next";

const SFCardFormContainer = ({
  title = null,
  subTitle = null,
  description = null,
  help = null,
  icon = null,
  addBottomMargin = false,
  style = {},
  children,
}) => {
  //const { t } = useTranslation();

  return (
    <StyledForm
      addBottomMargin={addBottomMargin}
      style={style}
    >
      {title && (
        <StyledHeading variant="h2">
          {icon}
          {title}
        </StyledHeading>
      )}
      {title && description && (
        <SFTypography variant="body1">{description}</SFTypography>
      )}
      {title && help && (
        <SFTypography variant="body1bold">
          <InfoIcon /> {help}
        </SFTypography>
      )}
      {subTitle && (
        <StyledSubHeading variant="cardSectionHeading">
          {subTitle}
        </StyledSubHeading>
      )}
      {!title && subTitle && description && (
        <SFTypography variant="body1">{description}</SFTypography>
      )}
      {!title && subTitle && help && (
        <SFTypography variant="body1bold">
          <InfoIcon /> {help}
        </SFTypography>
      )}

      {children}
    </StyledForm>
  );
};

export default SFCardFormContainer;
